import React from "react";
import type { TFunction } from "i18next";
import IconRedAlert from "~/components/Icons/alert-triangle";
import IconYellowAlert from "~/components/Icons/alert-square";
import IconMinorAlert from "~/components/Icons/alert-circle";
import s from "./Cells.less";

interface CategoryCellProps {
  category?: string | null;
  t: TFunction;
  translationPrefix?: string;
}

export const CategoryCell: React.FC<CategoryCellProps> = ({
  category,
  t,
  translationPrefix = "violationsTable",
}) => {
  if (!category) return <span>-</span>;

  switch (category) {
    case "critical":
      return (
        <span className={s.hover_text}>
          <IconRedAlert />
          <span>{t(`${translationPrefix}.critical`)}</span>
        </span>
      );
    case "operational":
      return (
        <span className={s.hover_text}>
          <IconYellowAlert />
          <span>{t(`${translationPrefix}.operational`)}</span>
        </span>
      );
    case "minor":
      return (
        <span className={s.hover_text}>
          <IconMinorAlert />
          <span>{t(`${translationPrefix}.minor`)}</span>
        </span>
      );
    default:
      return <span>{String(category)}</span>;
  }
};
